































import Component, { mixins } from "vue-class-component";
import AxiosMixin from "../../mixins/axiosMixin";
import { Emit } from "vue-property-decorator";
import { PulldownItem } from "@/types";
import Cookies from "js-cookie";

//事業所選択エリア
export interface OfficeSelectItem extends PulldownItem {
  unique_id: number;
}

@Component
export default class OfficeSelect extends mixins(AxiosMixin) {
  private selectId = 0;
  private offices: OfficeSelectItem[] = [];

  created() {
    this.postJsonCheck(window.base_url + "/api/ibow_office/get", {}, res => {
      this.offices = res.data.office;
    });
  }

  get selectItem(): OfficeSelectItem | undefined {
    return this.offices.find(v => {
      if (v.value == this.selectId) {
        return true;
      } else {
        return false;
      }
    });
  }

  private clickSelect() {
    this.postJsonCheck(
      window.auth_backend_url + "/outer/auth/receiptoffice/token",
      {
        receipt_office_id: this.selectItem?.value
      },
      res => {
        window.token = res.data.token;
        //レセプト用のトークンはcookieに記憶しない
        // Cookies.set("token", window.token);
        window.reftoken = res.data.ref_token;
        //レセプト用のトークンはcookieに記憶しない
        // Cookies.set("reftoken", window.reftoken);
        if (this.selectItem) {
          window.office_name = this.selectItem.text;
          Cookies.set("office_name", window.office_name);
          window.office_id = this.selectItem?.value;
          Cookies.set("office_id", String(window.office_id));
        }
        this.select();
      }
    );
  }

  @Emit()
  private select() {
    return;
  }
}
